import { Option } from '~/core/shared/types';

export enum ResidentialStatus {
  OwningUnencumbered = 'Owning (Unencumbered)',
  BuyingMortgaged = 'Buying (Mortgaged)',
  SpousalProperty = 'Spousal Property (Spouse on Title)',
  Renting = 'Renting (on Tenancy Agreement)',
  LivingWithParents = 'Living With Parents',
  Boarding = 'Boarding',
  Other = 'Other',
}

export const RESIDENTIAL_STATUS_OPTIONS_FULL: Option[] = [
  {
    label: 'Owning (Unencumbered)',
    value: ResidentialStatus.OwningUnencumbered,
  },
  {
    label: 'Buying (Mortgaged)',
    value: ResidentialStatus.BuyingMortgaged,
  },
  {
    label: 'Spousal Property (Spouse on Title)',
    value: ResidentialStatus.SpousalProperty,
  },
  {
    label: 'Renting (on Tenancy Agreement)',
    value: ResidentialStatus.Renting,
  },
  {
    label: 'Living With Parents',
    value: ResidentialStatus.LivingWithParents,
  },
  {
    label: 'Boarding',
    value: ResidentialStatus.Boarding,
  },
  {
    label: 'Other',
    value: ResidentialStatus.Other,
  },
];

export const RESIDENTIAL_STATUS_OPTIONS: Option[] = [
  {
    label: 'Owning (Unencumbered)',
    value: ResidentialStatus.OwningUnencumbered,
  },
  {
    label: 'Buying (Mortgaged)',
    value: ResidentialStatus.BuyingMortgaged,
  },
  {
    label: 'Renting (on Tenancy Agreement)',
    value: ResidentialStatus.Renting,
  },
  {
    label: 'Living With Parents',
    value: ResidentialStatus.LivingWithParents,
  },
  {
    label: 'Boarding',
    value: ResidentialStatus.Boarding,
  },
];
